var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      style: { top: _vm.top, left: _vm.left, "text-align": "center" },
      on: {
        contextmenu: function($event) {
          _vm.showContextMenu($event)
        },
        click: function($event) {
          _vm.showUITextDetails($event)
        }
      }
    },
    [
      _c("span", [
        _c("span", { staticClass: "subheading" }, [
          _vm._v(_vm._s(_vm.myText.label))
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4bf44f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bf44f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/UIText.vue
// module id = null
// module chunks = 